'use client'

import Link from 'next/link'
import React from 'react'

import { addBrowsingParameter } from '@/utils/urlUtils'

type Props = {
  href: string
  className?: string
  nextLink: boolean
  target?: string | null
  onClick?: () => void
  style?: React.CSSProperties
  children: React.ReactNode
}

const ULink = ({ href, className = '', children, nextLink, target = null, onClick = () => {}, style = {} }: Props) => {
  if (nextLink) {
    return (
      <Link href={href} className={className} target={target ? target : '_self'} onClick={onClick} style={style}>
        {children}
      </Link>
    )
  }

  return (
    <a href={addBrowsingParameter(href)} className={className}>
      {children}
    </a>
  )
}

export default ULink
